module.exports = "<button type=button @click=expand><i v-bind:class=\"{'fa-plus': !expanded, 'fa-minus': expanded }\" class=fa></i></button>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/tables/cells/expander.vue
// module id = 471
// module chunks = 0